export default __webpack_public_path__ + "1444bee0828487b72886b91c5c3be74d.png";